export const OWNER_CONTACT_ROLE_NAME = "Owner";
export const ADMIN_CONTACT_ROLE_NAME = "Admin";
export const STANDARD_CONTACT_ROLE_NAME = "Standard";
export const GUEST_CONTACT_ROLE_NAME = "Guest";
export const SYSTEM_ADMIN_ROLE_NAME = "System Admin";

export const HUBSPOT_CONNECTOR_TAP = "hubspot-beta";
export const NETSUITE_CONNECTOR_TAP = "netsuite-rest";
export const SALESFORCE_CONNECTOR_TAP = "salesforce";

export const STRIPE_CARD_BRAND_ICONS = {
    visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
    mastercard: 'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
    amex: 'https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg',
    discover: 'https://js.stripe.com/v3/fingerprinted/img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg',
    jcb: 'https://js.stripe.com/v3/fingerprinted/img/jcb-271fd06e6e7a2c52692ffa91a95fb64f.svg',
    diners: 'https://js.stripe.com/v3/fingerprinted/img/diners-fbcbd3360f8e3f629cdaa80e93abdb8b.svg',
    unknown: 'https://js.stripe.com/v3/fingerprinted/img/generic-e04b16bb497b69233f91aa05b89bd79f.svg'
};

export function buildRoutePrefix(instanceId: string): string {
    return `${baseRoutePrefix()}${instanceId}`;  
}
export function baseRoutePrefix(): string {
    return '/dashboard/instance/';
}